import { useUser } from "@clerk/nextjs";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useTRPC } from "@/frontend/lib/trpc";

// QUERIES
export function usePlanQuery() {
  const { user } = useUser();
  const trpc = useTRPC();
  return useQuery({
    ...trpc.subscription.getPlan.queryOptions(),
    enabled: !!user,
  });
}

export function useCurrentPeriodEndQuery() {
  const { user } = useUser();
  const trpc = useTRPC();
  return useQuery({
    ...trpc.subscription.getCurrentPeriodEnd.queryOptions(),
    enabled: !!user,
  });
}

export function useStripeSubscriptionQuery() {
  const { user } = useUser();
  const trpc = useTRPC();
  return useQuery({
    ...trpc.subscription.getStripeSubscription.queryOptions(),
    enabled: !!user,
  });
}

// MUTATIONS
export function useCreateBillingPortalSession() {
  const trpc = useTRPC();
  return useMutation(trpc.subscription.createBillingPortalSession.mutationOptions());
}

export function useCreateSubscriptionCheckoutSession() {
  const trpc = useTRPC();
  return useMutation(trpc.subscription.createSubscriptionCheckoutSession.mutationOptions());
}

export function useUpgradeSubscription() {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  
  return useMutation({
    ...trpc.subscription.upgradeSubscription.mutationOptions(),
    onSettled: async () => {
      await queryClient.invalidateQueries(trpc.subscription.getPlan.queryFilter());
      await queryClient.invalidateQueries(trpc.subscription.getCurrentPeriodEnd.queryFilter());
      await queryClient.invalidateQueries(trpc.subscription.getStripeSubscription.queryFilter());
    },
  });
}

export function useDowngradeSubscription() {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  
  return useMutation({
    ...trpc.subscription.downgradeSubscription.mutationOptions(),
    onSettled: async () => {
      await queryClient.invalidateQueries(trpc.subscription.getPlan.queryFilter());
      await queryClient.invalidateQueries(trpc.subscription.getCurrentPeriodEnd.queryFilter());
      await queryClient.invalidateQueries(trpc.subscription.getStripeSubscription.queryFilter());
    },
  });
}

export function useCreateExtraHoursCheckout() {
  const trpc = useTRPC();
  return useMutation(trpc.subscription.createExtraHoursCheckoutSession.mutationOptions());
}